var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":"Start recording"},on:{"click":_vm.startRecordingCLick}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faDotCircle}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2354df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rep-call/toolbar/recording-button/recording-start-button.vue
// module id = 2SSd
// module chunks = 1